export default __webpack_public_path__ + "static/media/AT002.fe99f6e4.mp3";